import { jsx as p } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { e as l } from "./palettes-DoFdaGi8.js";
import { c as f } from "./cn-DlLpp5ix.js";
const g = {
  sm: "var(--text-2xs)",
  md: "var(--text-xs)"
}, u = {
  sm: "var(--space-0_5) var(--space-1_5)",
  md: "var(--space-1) var(--space-2)"
}, v = {
  sm: "var(--radius-sm)",
  md: "var(--radius-md)"
}, x = i(function({ children: s, tone: e = "neutral", variant: r = "soft", size: a = "sm", className: o, style: n, ...d }, c) {
  const t = l[e], m = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "var(--space-1)",
    padding: u[a],
    fontSize: g[a],
    fontWeight: 600,
    lineHeight: 1.2,
    borderRadius: v[a],
    color: t.fg,
    background: r === "outline" ? "transparent" : t.bg,
    border: `1px solid ${t.border}`,
    whiteSpace: "nowrap",
    ...n
  };
  return /* @__PURE__ */ p(
    "span",
    {
      ref: c,
      "data-ls-component": "badge",
      "data-tone": e,
      "data-variant": r,
      "data-size": a,
      className: f(o),
      style: m,
      ...d,
      children: s
    }
  );
});
x.displayName = "Badge";
export {
  x as B
};
//# sourceMappingURL=Badge-CFXhhPxG.js.map
